<template>
    <div class="content">
        <center>
            <h3 style="display:inline-block">Editar Términos y condiciones</h3>
            <i @click="showInfo()" class="el-icon-question help-icon"></i>        
        </center>
        <br><br>
        <div class="containerAdmin">
            <el-row :gutter="20">
                <el-col :xs="24" :md="10" :offset="8">
                    <label class="font-weight-bold">Terminos y condiciones a editar</label><br>
                    <el-select id="hotel" placeholder="Seleccione un idioma" v-model="idiomaSelected">
                        <el-option  
                            key="en"                           
                            value="ingles"
                            label="inglés">
                            inglés
                        </el-option>
                        <el-option
                            selected="true"
                            key="es"                         
                            value="espaniol"
                            label="español">
                            español
                        </el-option>
                    </el-select>
                </el-col>              
            </el-row>
            <br>
            <el-row :gutter="20" v-show="idiomaSelected== 'ingles'">
                <el-col :xs="24" :md="22" :offset="1">
                    <label class="font-weight-bold">Terminos y condiciones</label><br>
                    <ckeditor :editor="editor" v-model="editorDataIngles" :config="editorConfig"></ckeditor>
                </el-col>                            
            </el-row>     
            <el-row :gutter="20" v-show="idiomaSelected== 'espaniol'">
                <el-col :xs="24" :md="22" :offset="1">
                    <label class="font-weight-bold">Terminos y condiciones</label><br>
                    <ckeditor :editor="editor" v-model="editorDataEspaniol" :config="editorConfig"></ckeditor>
                </el-col>                            
            </el-row>  
            <el-row :gutter="20">                    
                <el-col :xs="24" :md="10" :offset="8">
                    <br>
                    <input @click="editTerms" value="Actualizar" class="btn btn-primary pill px-4 py-2">
                </el-col>        
            </el-row>      
        </div>
    </div>
</template>

<script>
import { db, storage } from '@/firebase.js'
import moment from "moment"
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    data () {
      return {
        editor: ClassicEditor,
        editorDataIngles: '',
        editorDataEspaniol: '',
        editorConfig: {
            // The configuration of the editor.
        },
        /*variables para la info */
        messaje: 'En este módulo le será posible actualizar los términos y condiciones de su empresa, para comenzar primero necesita seleccionar el idioma que desea editar, luego de esto se cargarán los datos ya almacenados en la base de datos y usted podrá editarlos, posteriormente presiona el boton "Actualizar" y la información será actualizada y ya se verá reflejada en la página web.',
        title: 'Actualizar Terminos y condiciones',
        /*fin variables para info */
        idiomaSelected: null,
        /* */       
        terms: [],        
        terminosRef: db.child("terminos")
      }
    },    
    methods:{
        async editTerms() {
            if(this.idiomaSelected == null){
                this.$message.error('Debe seleccionar un idioma y editarlo para poder actualizar');
                return
            }
            try {
                const key = 'idiomasDelSistemaTambo';                
                const update = {
                    ingles: this.editorDataIngles,
                    espaniol: this.editorDataEspaniol
                }
                await this.terminosRef.child(key).set(update)                
                await this.getTerms()
                // Y así puedes handlear el error como te de la puta gana we hee hee ayuwoki
            } catch (ex) {
                return console.error(ex)
            }
            this.success();           
        
        },
        async getTerms () {
            try {
                  this.terms = (
                    await db
                    .child("terminos")                    
                    .once("value")                     
                ).val()

                this.editorDataIngles = this.terms.idiomasDelSistemaTambo.ingles
                this.editorDataEspaniol = this.terms.idiomasDelSistemaTambo.espaniol
            } catch (ex) {
                return console.error(ex)
            }            
        },       
        success () {
            this.$message({
                message: 'Términos actualizados satisfactoriamente.',
                type: 'success'
            });
        },
        failure () {
            this.$message.error('Ha Ocurrido un error, intente de nuevo más tarde');
        },  
        showInfo() {
            this.$alert(this.messaje, this.title, {
            confirmButtonText: 'OK',          
            });
        }        
    }, 
    async created () {
        await this.getTerms()
    }
}
</script>

<style scoped>
   
</style>



// WEBPACK FOOTER //
// Update.vue?68ba78f4